import { render, staticRenderFns } from "./SerialPopup.vue?vue&type=template&id=b3ac8368"
import script from "./SerialPopup.vue?vue&type=script&lang=js"
export * from "./SerialPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports